import { watchEffect, type Directive, type WatchStopHandle } from 'vue'
import type { Permission } from '@shared/domain/permissions'
import { useAuthStore } from '@shared/stores/auth'

type CanValue = Permission | Permission[]
type CanElement = HTMLElement & { __vCanStop?: WatchStopHandle; __vCanValue?: CanValue }

/**
 * `<BaseButton v-can="P.SUPPLIER_FINANCING_SUBMIT">` hides the element unless the user has the
 * permission (an array means any of them). Cosmetic only: the API enforces access.
 */
export const vCan: Directive<CanElement, CanValue> = {
  mounted(el, binding) {
    const auth = useAuthStore()
    el.__vCanValue = binding.value
    el.__vCanStop = watchEffect(() => {
      const value = el.__vCanValue
      const allowed = Array.isArray(value) ? auth.canAny(value) : !!value && auth.can(value)
      el.hidden = !allowed
      if (allowed) el.removeAttribute('aria-hidden')
      else el.setAttribute('aria-hidden', 'true')
    })
  },
  updated(el, binding) {
    el.__vCanValue = binding.value
  },
  unmounted(el) {
    el.__vCanStop?.()
  },
}
